import { inputDescLimit, inputTextLimit } from '../../../helpers/fieldRestriction';
import messages from '../../../locale/jsonMessages';

const validate = (values, props) => {

  const errors = {}
  const activeLanguageCodes = props?.activeLanguageCodes || [];

  const validateDynamicField = (fieldData = [], key, limit, errorKey) => {
    const fieldErrors = [];
    fieldData?.forEach((item, index) => {
      const currentError = {};
      const isLanguageInactive = item?.language && activeLanguageCodes.length > 0
        && !activeLanguageCodes.includes(item.language);

      if (!item?.[key] || item?.[key]?.toString()?.trim() === '') {
        currentError[key] = messages.required;
      } else if (item?.[key]?.length > limit) {
        currentError[key] = errorKey;
      }

      if (!item?.language || item?.language?.toString()?.trim() === '' || isLanguageInactive) {
        currentError.language = messages.required;
      }

      if (Object.keys(currentError).length > 0) {
        fieldErrors[index] = currentError;
      }
    });

    return fieldErrors?.length > 0 ? fieldErrors : undefined;
  };

  const validateTripDetailsField = (fieldData = []) => {
    const fieldErrors = [];
    fieldData?.forEach((item, index) => {
      const currentError = {};
      const isLanguageInactive = item?.language && activeLanguageCodes.length > 0
        && !activeLanguageCodes.includes(item.language);

      if (!item?.title || item?.title?.toString()?.trim() === '') {
        currentError.title = messages.required;
      } else if (item?.title?.length > inputTextLimit) {
        currentError.title = messages.inputTextLimitError;
      }

      if (!item?.content || item?.content?.toString()?.trim() === '') {
        currentError.content = messages.required;
      } else if (item?.content?.length > inputDescLimit) {
        currentError.content = messages.inputDescLimitError;
      }

      if (!item?.language || item?.language?.toString()?.trim() === '' || isLanguageInactive) {
        currentError.language = messages.required;
      }

      if (Object.keys(currentError).length > 0) {
        fieldErrors[index] = currentError;
      }
    });

    return fieldErrors?.length > 0 ? fieldErrors : undefined;
  };

  errors.carTripTitle1 = validateDynamicField(values?.carTripTitle1, 'title', inputTextLimit, messages.inputTextLimitError);
  errors.carTripDetails2 = validateTripDetailsField(values?.carTripDetails2);
  errors.carTripDetails3 = validateTripDetailsField(values?.carTripDetails3);


  return errors
}

export default validate;